import React from 'react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { Reveal } from '../Reveal';
export function Oferta() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="w-full bg-grisclaro px-4 py-16 sm:px-6 sm:py-20" data-id="element-182" data-mp="2tdsc4hucz50z">
      <div className="mx-auto max-w-4xl" data-id="element-183" data-mp="2kjdz6lxaw6l1">
        <Reveal data-id="element-184" data-mp="2kicowjo3zo4d">
          <Countdown data-id="element-185" data-mp="2kivud0wkok1i" />
        </Reveal>

        <Reveal delay={0.05} data-id="element-186" data-mp="2fjrnigx4eyec">
          <p className="mt-6 text-center text-sm text-tintasuave sm:text-base" data-id="element-187" data-mp="2fl2n04jj9jzn">
            Oferta especial de lanzamiento disponible por tiempo limitado.
          </p>
        </Reveal>

        <Reveal delay={0.07} data-id="element-188" data-mp="25l3h6fei07qh">
          <p className="mx-auto mt-5 w-fit rounded-full border border-bordo/15 bg-white px-4 py-2 text-xs font-semibold text-bordo shadow-sm sm:text-sm" data-id="element-189" data-mp="25mdg16t6djy6">
            🔴 Precio especial de lanzamiento activo
          </p>
        </Reveal>

        <Reveal delay={0.09} data-id="element-190" data-mp="3vyb0ovao8o9a">
          <div className="mt-14 text-center" data-id="element-191" data-mp="3vy1bh9xgal4n">
            <h2 id="oferta-titulo" className="font-display text-3xl font-bold text-bordo sm:text-4xl" data-id="element-192" data-mp="3vw6mnkj268va">
              Llevate tu Profes de Telas Resuelto hoy:
            </h2>
            <p className="mt-3 text-base text-tintasuave sm:text-lg" data-id="element-193" data-mp="5297kovy9odz">
              Una única oferta con los 7 tomos y los 5 bonos completos.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-194" data-mp="3r8nxm1tuhxg9">
          <div className="mt-10" data-id="element-195" data-mp="3r9z1e1naj57d">
            <PriceCard ctaLabel="→ SÍ, QUIERO TODO EL SISTEMA" footnote="La elección de las profes que quieren enseñar con seguridad, ahorrar tiempo y verse como las profesionales que realmente son." data-id="element-196" data-mp="isckgp8xw5qr" />
          </div>
        </Reveal>
      </div>
    </section>;
}